// Games library metadata (used by Games hub + individual game routes)
// Games without an explicit `kind` are treated as arcade. Brain/board games are
// tagged so the homepage can surface them under "Brain boosters".
export const GAMES = [
  {
    id: "spin",
    name: "Spin the Wheel",
    emoji: "🎡",
    tagline: "Spin & win coins!",
    color: "#FF5A5F",
    reward: "up to 200",
  },
  {
    id: "linerace",
    name: "Line Racer",
    emoji: "🏁",
    tagline: "3-lane tap dodge",
    color: "#FF5A5F",
    reward: "up to 200",
  },
  {
    id: "maze",
    name: "Maze Rush",
    emoji: "🐭",
    tagline: "Mouse to cheese in 60s",
    color: "#00A699",
    reward: "up to 200",
  },
  {
    id: "cups",
    name: "Cup & Ball",
    emoji: "🎩",
    tagline: "Follow the ball",
    color: "#F368E0",
    reward: "30 coins",
  },
  {
    id: "memory",
    name: "Memory Match",
    emoji: "🧠",
    tagline: "Find the pairs",
    color: "#00A699",
    reward: "up to 80",
  },
  {
    id: "balloon",
    name: "Balloon Pop",
    emoji: "🎈",
    tagline: "Pop 'em all!",
    color: "#54A0FF",
    reward: "5 per pop",
  },
  {
    id: "scratch",
    name: "Lucky Scratch",
    emoji: "🎟️",
    tagline: "Scratch to reveal",
    color: "#FFB400",
    reward: "10-100",
  },
  {
    id: "tap",
    name: "Quick Tap",
    emoji: "⚡",
    tagline: "Hit the target",
    color: "#5F27CD",
    reward: "3 per tap",
  },
  {
    id: "inflate",
    name: "Balloon Inflator",
    emoji: "🎪",
    tagline: "Pump — but not too much!",
    color: "#FF9F1C",
    reward: "up to 120",
  },
  {
    id: "whack",
    name: "Whack-A-Mole",
    emoji: "🐹",
    tagline: "Bonk 'em quick",
    color: "#8B4513",
    reward: "5 per bonk",
  },
  {
    id: "stack",
    name: "Stack Tower",
    emoji: "🏗️",
    tagline: "Build it high!",
    color: "#48DBFB",
    reward: "10 per floor",
  },
  {
    id: "cookie",
    name: "Cookie Cruncher",
    emoji: "🍪",
    tagline: "Tap-tap-tap-crunch",
    color: "#8B4513",
    reward: "2 per bite",
  },
  {
    id: "reflex",
    name: "Reflex Duel",
    emoji: "🚦",
    tagline: "Wait for the GO!",
    color: "#34C759",
    reward: "up to 60",
  },
  {
    id: "tug",
    name: "Bumper Tug-of-War",
    emoji: "💪",
    tagline: "Out-pull the AI",
    color: "#FF5A5F",
    reward: "100 win",
  },
  {
    id: "popit",
    name: "Pop-it Rush",
    emoji: "🫧",
    tagline: "Pop the whole board fast",
    color: "#F368E0",
    reward: "up to 125",
  },
  {
    id: "slime",
    name: "Slime Slap",
    emoji: "🟢",
    tagline: "Slap the wobbling slime",
    color: "#00A699",
    reward: "6 per slap",
  },
  {
    id: "sumo",
    name: "Finger Sumo",
    emoji: "🤼",
    tagline: "Shove the robot off",
    color: "#FFB400",
    reward: "100 win",
  },
  {
    id: "sniper",
    name: "Target Sniper",
    emoji: "🎯",
    tagline: "Snipe moving targets",
    color: "#FF5A5F",
    reward: "up to 150",
  },
  {
    id: "pendulum",
    name: "Pendulum Drop",
    emoji: "🕰️",
    tagline: "Time your drop",
    color: "#54A0FF",
    reward: "up to 200",
  },
  {
    id: "orbit",
    name: "Orbit Launcher",
    emoji: "🪐",
    tagline: "Launch into orbit",
    color: "#5F27CD",
    reward: "up to 180",
  },
  {
    id: "golf",
    name: "Hole-in-One Golf",
    emoji: "⛳",
    tagline: "Aim, power, sink!",
    color: "#54D62C",
    reward: "up to 200",
  },
  {
    id: "hockey",
    name: "Soccer Air Hockey",
    emoji: "🏒",
    tagline: "First to 3 wins",
    color: "#00A699",
    reward: "up to 125",
  },
  {
    id: "sub",
    name: "Submarine Torpedoes",
    emoji: "🛥️",
    tagline: "Blast the ships",
    color: "#54A0FF",
    reward: "12 per hit",
  },
  {
    id: "magnet",
    name: "Magnet Catch",
    emoji: "🧲",
    tagline: "Catch metal, dodge food",
    color: "#5F27CD",
    reward: "10 per metal",
  },
  {
    id: "asteroid",
    name: "Road Dodger",
    emoji: "🚧",
    tagline: "Swerve past signs and puddles",
    color: "#5F27CD",
    reward: "up to 150",
  },
  {
    id: "volley",
    name: "Volleyball Bounce",
    emoji: "🏐",
    tagline: "First to 5 wins the set",
    color: "#00A699",
    reward: "120 win",
  },
  {
    id: "slicer",
    name: "Fruit Slicer Clash",
    emoji: "🍉",
    tagline: "Slice fruit — dodge bombs!",
    color: "#54D62C",
    reward: "5 per fruit",
  },
  {
    id: "cst",
    name: "Color Switch Tap",
    emoji: "🎨",
    tagline: "Word matches color? Tap!",
    color: "#5F27CD",
    reward: "12 per hit",
  },
  {
    id: "mathquiz",
    name: "Math Quiz",
    emoji: "🧮",
    tagline: "Pick your age, solve fast!",
    color: "#54A0FF",
    reward: "up to 90",
    kind: "brain",
  },
  {
    id: "count",
    name: "Number Count",
    emoji: "🔢",
    tagline: "Count the critters",
    color: "#F368E0",
    reward: "up to 100",
    kind: "brain",
  },
  {
    id: "multiply",
    name: "Multiply Master",
    emoji: "✖️",
    tagline: "Beat the 30s clock",
    color: "#5F27CD",
    reward: "8 per correct",
    kind: "brain",
  },
  {
    id: "wordprob",
    name: "Word Problems",
    emoji: "📖",
    tagline: "Read the story, do the math",
    color: "#00A699",
    reward: "up to 120",
    kind: "brain",
  },
  {
    id: "trivia",
    name: "Trivia MCQ",
    emoji: "🧠",
    tagline: "Six fun quiz questions",
    color: "#FFB400",
    reward: "up to 108",
    kind: "brain",
  },
  {
    id: "ttt",
    name: "Tic-Tac-Toe",
    emoji: "❌",
    tagline: "Beat the AI 3-in-a-row",
    color: "#FF5A5F",
    reward: "120 win",
    kind: "board",
  },
  {
    id: "snakes",
    name: "Snakes & Ladders",
    emoji: "🐍",
    tagline: "Roll dice, race to 25",
    color: "#54D62C",
    reward: "150 win",
    kind: "board",
  },
  {
    id: "scramble",
    name: "Word Scramble",
    emoji: "🔤",
    tagline: "Unscramble kid words",
    color: "#F368E0",
    reward: "up to 125",
    kind: "brain",
  },
  {
    id: "odd",
    name: "Odd One Out",
    emoji: "🔍",
    tagline: "Spot the different picture",
    color: "#00A699",
    reward: "up to 120",
    kind: "brain",
  },
  {
    id: "simon",
    name: "Simon Memory",
    emoji: "🧠",
    tagline: "Copy the color pattern",
    color: "#8E6BFF",
    reward: "up to 180",
    kind: "brain",
  },
  {
    id: "merge",
    name: "Merge Blocks Blast",
    emoji: "🧊",
    tagline: "Slide & double neon tiles",
    color: "#5F27CD",
    reward: "up to 200",
    kind: "brain",
  },
];

export const getGameById = (id) => GAMES.find((g) => g.id === id);

// Convenience selectors for the homepage/games hub.
export const BRAIN_GAMES = GAMES.filter((g) => g.kind === "brain" || g.kind === "board");
export const ARCADE_GAMES = GAMES.filter((g) => !g.kind || g.kind === "arcade");
